import { CoreIcon } from '../core-icon';
import visibilityOffSVG from '../../assets/icons/visibility-off.svg';
import type { IconProps } from '../core-icon';

export const VisibilityOffIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={visibilityOffSVG} {...props} />;
};
